import { render, staticRenderFns } from "./SkeltonListBlogs.vue?vue&type=template&id=65cec3a0&scoped=true&"
import script from "./SkeltonListBlogs.vue?vue&type=script&lang=js&"
export * from "./SkeltonListBlogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cec3a0",
  null
  
)

export default component.exports